<template>
  <nav aria-label="Progress">
    <div
      class="relative rounded-lg after:absolute after:inset-x-0 after:top-1/3 after:block after:h-0.5 after:-translate-y-1/2 after:rounded-lg after:bg-gray-500"
    >
      <ol
        class="relative z-10 flex items-center justify-between text-sm font-medium text-gray-500"
      >
        <li
          v-for="(step, stepIndex) in providedSteps"
          :key="stepIndex"
          class="bg-white p-2"
        >
          <div
            v-if="step.active && !step.completed"
            class="text-center"
          >
            <span
              class="ml-2 h-6 w-6 rounded-full bg-main-primary p-2 px-3 text-center text-[10px]/6 font-bold text-white"
            >
              {{ stepIndex + 1 }}
            </span>
            <span class="mt-2 hidden sm:block"> {{ step.title }} </span>
          </div>

          <div
            v-if="!step.active && !step.completed"
            class="text-center text-gray-300"
          >
            <span
              class="ml-2 h-6 w-6 rounded-full border-2 border-gray-300 p-2 px-3 text-center text-[10px]/6 font-bold text-gray-500"
            >
              {{ stepIndex + 1 }}
            </span>
            <span class="mt-2 hidden sm:block"> {{ step.title }}</span>
          </div>
          <div
            v-if="step.completed"
            href="#"
            class="group w-full text-center"
          >
            <span
              class="mb-1 ml-10 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-main-primary"
            >
              <svg
                class="h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
            <span class="ml-4 mt-2 text-sm font-medium text-gray-900">{{
              step.title
            }}</span>
          </div>
          <!-- <div
            v-if="step.completed"
            class="text-center text-gray-300"
          >
            <span class="h-6 w-6 p-2 px-3 ml-2 rounded-full bg-main-primary text-white text-center text-[10px]/6 font-bold">
              {{ stepIndex + 1 }}
            </span>
            <span class="hidden mt-2 sm:block"> {{ step.title }}</span>
          </div> -->
        </li>
      </ol>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'StepsNumberNavigation',

  props: {
    steps: {
      type: Array,
      default: () => [
        {
          active: true,
          completed: true,
          title: 'First',
        },
        {
          active: true,
          completed: false,
          title: 'Second',
        },
        {
          active: false,
          completed: false,
          title: 'Last',
        },
      ],
    },
  },

  data() {
    return {
      providedSteps: this.steps,
    }
  },

  methods: {
    start() {
      this.providedSteps.forEach((step, index) => {
        step.active = index === 0
        step.completed = false
      })
    },
  },
}
</script>
